import React from "react";
import styled from "@emotion/styled";
import {useMediaQuery} from "react-responsive";
import {Flex, Heading, View, ViewProps} from "@adobe/react-spectrum";
import AppHeader from "./AppHeader";
import SectionFeedback from "./SectionFeedback";
import SectionAbout from "./SectionAbout";
import FlipButton from "./FlipButton";
import SectionTryThis from "./SectionTryThis";
import SectionFooter from "./SectionFooter";
import useAppStore from "../stores/useAppStore";
import {PHONE_MAX_WIDTH, TABLET_MAX_WIDTH} from "../utils/constants";

const SidePanelStyled = styled.div({
    display: "flex",
    flexDirection: "column",
    flex: "0.35",
    minWidth: "435px",
    backgroundColor: "#E6E3DC",
    height: "calc(var(--vh, 1vh) * 100)",
    overflowY: "auto"
});

function SidePanel() {

    const isRightHanded = useAppStore(state => state.isRightHanded);
    const isPortrait = useMediaQuery({query: "(orientation: portrait)"});
    const isTablet = useMediaQuery({minWidth: PHONE_MAX_WIDTH + 1, maxWidth: TABLET_MAX_WIDTH});
    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});

    const borderProps = (): ViewProps => {
        let props = {};
        if ((isTablet || isPhone) && isPortrait) return props;

        if (!isRightHanded) {
            props = {
                borderStartWidth: "thick",
                borderStartColor: "gray-500"
            };
        } else {
            props = {
                borderEndWidth: "thick",
                borderEndColor: "gray-500"
            };
        }

        return props;
    };

    return (
        <SidePanelStyled style={{minWidth: isTablet ? "315px" : "435px"}}>
            {/*{(isPortrait && !isTablet) ?
                <></>
                :
                <AppHeader/>
            }*/}
            <AppHeader/>
            <View padding="size-300"
                  flex={1}
                  {...borderProps()}>
                <Flex direction="column" alignItems="start" gap="size-200" flex={1}>
                    <Heading level={isTablet ? 2 : 1}>20,000+ fonts at your <em>fingertips</em></Heading>
                    <p className="fs-16"><strong>Type your text, use the joystick, and surprise yourself with amazing fonts</strong></p>
                    <Flex direction={(isTablet && isPortrait) ? "row-reverse" : "column"}
                          justifyContent="space-evenly"
                          gap="size-500">
                        <Flex direction="column" alignItems="start" gap="size-200">
                            {
                                ((isTablet && !isPortrait) || !isTablet) &&
                                <>
                                    <br/>
                                    <SectionAbout/>
                                </>
                            }
                            {!isPortrait && <br/>}
                            {((isTablet && !isPortrait) || !isTablet) &&
                                <>
                                    <SectionTryThis/>
                                    <FlipButton/>
                                    <br/>
                                </>
                            }
                            <SectionFeedback/>
                            {((isTablet && !isPortrait) || !isTablet) &&
                                <>
                                    <br/>
                                    <br/>
                                    <SectionFooter/>
                                </>
                            }
                        </Flex>
                        {(isTablet && isPortrait) && <SectionAbout/>}
                    </Flex>
                </Flex>
            </View>
        </SidePanelStyled>
    );
}

export default SidePanel;